import { useSelector } from "react-redux";
import { RootState } from "../modules/app/mainReducer";
import {
  resolveRegistroEntregaRegras,
  RegistroEntregaRegrasEfetivas,
} from "../utils/registroEntregaRegras";

export default function useRegistroEntregaRegras(): RegistroEntregaRegrasEfetivas {
  const documento = useSelector(
    (state: RootState) => state.login.parceiro?.cpf_cnpj
  );
  return resolveRegistroEntregaRegras(documento);
}
